import painter from "./index";
import DEFINE from "./define";
import EventBus from "../event_bus";

export default class PainterProxy {
    instance = null;

    // 紀錄所有painter
    painterMap = new Map();

    // 自定義變數名稱
    extraAttribute = [
        // 自定義屬性
        "tag", // 編號(定位物件用)
        "toolType", // 工具類型(復原事件用)
        "selectionActive", // 判斷是否在Selection模式須可被操控
        "data", // TODO:後續更改
        "cornerColor",
        // '_controlsVisibility',
        "fixedFlip",

        // fabric預設未保留
        "selectable",
        "perPixelTargetFind",
        "cornerColor",
        "transparentCorners",
        "subTargetCheck",
        "imageFileName",
        "title"
    ];

    // 主要的painter, 用於沒有目標painter時有對象
    mainPainterId = "";
    mainPainter = null;
    // 目前使用中的painter
    currentPainterId = "";
    currentPainter = null;

    // 主畫布頁面存檔
    mainPainterSaves = new Map();

    // 當前操作狀態
    currentOperate = DEFINE.OPERATE.SELECTION;

    // 當前工具名稱
    currentToolName = null;

    // 當前鼠標
    currentCursor = null;

    // 畫筆點擊功能
    isPenClick = true;

    // 畫筆的設定
    penColor = DEFINE.COLOR.PEN.RED;
    penDrawTool = DEFINE.DRAW_STYLE.FREE;
    penWidth = 2.5;
    penHollow = true;

    // 螢光筆的設定
    highLighterColor = DEFINE.COLOR.HIGHLIGHTER.YELLOW;
    highLighterDrawTool = DEFINE.DRAW_STYLE.STRAIGHT_LINE;
    highLighterWidth = 2.5;
    highLighterHollow = true;

    //雷射筆的設定
    laserPointerColor = DEFINE.COLOR.LASER_POINTER.PINK;
    laserPointerDrawTool = DEFINE.DRAW_STYLE.FREE_LASER;
    laserPointerWidth = 3;
    laserPointerHollow = true;

    // 印章圖片路徑
    stampImgUrl = null;

    constructor() {
        this.changeCursor("default");
    }

    static getInstance() {
        if (!PainterProxy.instance) {
            PainterProxy.instance = new PainterProxy();
        }
        return PainterProxy.instance;
    }

    //#region Painter操作

    /**
     * 重新設定main canvas尺寸
     * @param {Number} width 
     * @param {Number} height 
     */
    setMainPainterSize(width, height) {
        if (!this.getMainPainter().painter) return;
        this.getMainPainter().painter.setPainterSize(width, height);
    }

    /**
     * 重新設定當前 canvas尺寸
     * @param {Number} width 
     * @param {Number} height 
     */
    setCurrentPainterSize(width, height) {
        if (!this.getCurrentPainter().painter) return;
        this.getCurrentPainter().painter.setPainterSize(width, height);
    }

    /**
     * 刷新視野範圍
     */
    updateViewportTransform(x = null, y = null, scale = null) {
        if (!this.getCurrentPainter().painter) return;
        this.getCurrentPainter().painter.updateViewportTransform(
            (scale == 1) ? 0 : x,
            (scale == 1) ? 0 : y,
            scale
        );
    }

    /**
     * 設定畫布, 加入painterMap內
     * @param {string} canvasId
     */
    setPainter(canvasId, isMain = false, isCurrent = false) {
        if (this.painterMap.has(canvasId)) {
            throw `already set canvas: ${canvasId}`;
        } else {
            this.painterMap.set(canvasId, new painter(this, canvasId));

            if (isMain) {
                this.setMainPainter(canvasId);
            }
            if (isCurrent) {
                this.setCurrentPainter(canvasId);
                console.log("set current painter");
            }
        }
    }

    /**
     * 移除畫布, 從painterMap中移除
     * @param {string} canvasId
     */
    removePainter(canvasId) {
        if (!this.painterMap.has(canvasId)) {
            throw `canvas: ${canvasId} not found`;
        } else {
            this.painterMap.delete(canvasId);
        }
    }

    /**
     * 取得主畫布
     * @returns object
     */
    getMainPainter() {
        return {
            id: this.mainPainterId,
            painter: this.mainPainter,
        };
    }

    /**
     * 設定主畫布
     * @param {string} canvasId
     */
    setMainPainter(canvasId) {
        if (!this.painterMap.has(canvasId)) {
            throw `can not found canvas: ${canvasId}`;
        } else {
            this.mainPainterId = canvasId;
            this.mainPainter = this.painterMap.get(canvasId);
        }
    }

    /**
     * 取得當前畫布
     * @returns object
     */
    getCurrentPainter() {
        return {
            id: this.currentPainterId == ""
                ? this.mainPainterId
                : this.currentPainterId,
            painter:
                this.currentPainter == null ? this.mainPainter : this.currentPainter,
        };
    }

    /**
     * 設定當前畫布
     * @param {string} canvasId
     */
    setCurrentPainter(canvasId) {
        if (!this.painterMap.has(canvasId)) {
            throw `can not found canvas: ${canvasId}`;
        } else {
            this.currentPainterId = canvasId;
            this.currentPainter = this.painterMap.get(canvasId);
            this.currentPainter.changeTool(this.currentToolName);
            this.currentPainter.changeCursor(this.currentCursor);
        }
    }

    /**
     * 清除當前畫布
     */
    removeCurrentPainter() {
        this.currentPainterId = "";
        this.currentPainter = null;
    }

    //#endregion

    //#region 畫筆與操作設定

    /**
     * 取得操作狀態
     * @returns DEFINE.OPERATE
     */
    getOperate() {
        return this.currentOperate;
    }

    /**
     * 設定操作狀態
     * @param {DEFINE.OPERATE} operate
     */
    setOperate(operate) {
        this.currentOperate = operate;
        console.log(`current operate: ${this.currentOperate}`)
    }

    /**
     * 取得形狀
     * @param {DEFINE.TYPE} type 畫筆類型，僅支援PEN與HIGHLIGHTER
     * @returns number
     */
    getDrawTool(type) {
        switch (type) {
            case DEFINE.OPERATE.PEN:
                return this.penDrawTool;
            case DEFINE.OPERATE.HIGHLIGHTER:
                return this.highLighterDrawTool;
            case DEFINE.OPERATE.LASER_POINTER:
                return this.laserPointerDrawTool;
            default:
                throw `TypeError: getDrawTool type(${type}) is not define.`;
        }
    }

    /**
     * 設定形狀
     * @param {DEFINE.TYPE} type 畫筆類型，僅支援PEN與HIGHLIGHTER
     * @param {DEFINE.TOOLS} drawTool
     */
    setDrawTool(type, drawTool) {
        switch (type) {
            case DEFINE.OPERATE.PEN:
                this.penDrawTool = drawTool;
                break;
            case DEFINE.OPERATE.HIGHLIGHTER:
                this.highLighterDrawTool = drawTool;
                break;
            case DEFINE.OPERATE.LASER_POINTER:
                this.laserPointerDrawTool = drawTool;
                break;
            default:
                throw `TypeError: setDrawTool type(${type}) is not define.`;
        }
    }

    /**
     * 取得顏色
     * @param {DEFINE.TYPE} type 畫筆類型，僅支援PEN與HIGHLIGHTER
     * @returns string
     */
    getColor(type) {
        switch (type) {
            case DEFINE.OPERATE.PEN:
                return this.penColor;
            case DEFINE.OPERATE.HIGHLIGHTER:
                return this.highLighterColor;
            case DEFINE.OPERATE.LASER_POINTER:
                return this.laserPointerColor;
            default:
                return DEFINE.COLOR.TRANSPARENT;
        }
    }

    /**
     * 設定顏色
     * @param {DEFINE.TYPE} type 畫筆類型，僅支援PEN與HIGHLIGHTER
     * @param {DEFINE.COLOR} color
     */
    setColor(type, color = null) {
        switch (type) {
            case DEFINE.OPERATE.PEN:
                if (color == null) {
                    this.penColor = "rgba(0,0,0,1)";
                } else {
                    this.penColor = color;
                }
                break;
            case DEFINE.OPERATE.HIGHLIGHTER:
                if (color == null) {
                    this.highLighterColor = "rgba(0,0,0,0.5)";
                } else {
                    this.highLighterColor = color;
                }
                break;
            case DEFINE.OPERATE.LASER_POINTER:
                if (color == null) {
                    this.laserPointerColor = "rgba(0,0,0,0.5)";
                } else {
                    this.laserPointerColor = color;
                }
                break;
            default:
                throw `TypeError: setColor type(${type}) is not define.`;
        }
    }

    /**
     * 取得畫筆寬度
     * @param {DEFINE.TYPE} type 畫筆類型，僅支援PEN與HIGHLIGHTER
     * @returns number
     */
    getWidth(type) {
        switch (type) {
            case DEFINE.OPERATE.PEN:
                return this.penWidth;
            case DEFINE.OPERATE.HIGHLIGHTER:
                return this.highLighterWidth;
            case DEFINE.OPERATE.LASER_POINTER:
                return this.laserPointerWidth;
            default:
                return 0;
        }
    }

    /**
     * 設定畫筆寬度
     * @param {DEFINE.TYPE} type 畫筆類型，僅支援PEN與HIGHLIGHTER
     * @param {Number} width
     */
    setWidth(type, width = 0.1) {
        switch (type) {
            case DEFINE.OPERATE.PEN:
                this.penWidth = width;
                break;
            case DEFINE.OPERATE.HIGHLIGHTER:
                this.highLighterWidth = width;
                break;
            case DEFINE.OPERATE.LASER_POINTER:
                this.laserPointerWidth = width;
                break;
            default:
                throw `TypeError: setWidth type(${type}) is not define.`;
        }
    }

    /**
     * 取得是否空心
     * @param {DEFINE.TYPE} type 畫筆類型，僅支援PEN與HIGHLIGHTER
     * @returns boolean
     */
    getHollow(type) {
        switch (type) {
            case DEFINE.OPERATE.PEN:
                return this.penHollow;
            case DEFINE.OPERATE.HIGHLIGHTER:
                return this.highLighterHollow;
            case DEFINE.OPERATE.LASER_POINTER:
                return this.laserPointerHollow;
            default:
                return false;
        }
    }

    /**
     * 設定是否空心
     * @param {DEFINE.TYPE} type 畫筆類型，僅支援PEN與HIGHLIGHTER
     * @param {Boolean} isHollow true為空心，false為實心
     */
    setHollow(type, isHollow = false) {
        switch (type) {
            case DEFINE.OPERATE.PEN:
                this.penHollow = isHollow;
                break;
            case DEFINE.OPERATE.HIGHLIGHTER:
                this.highLighterHollow = isHollow;
                break;
            case DEFINE.OPERATE.LASER_POINTER:
                this.laserPointerHollow = isHollow;
                break;
            default:
                throw `TypeError: setHollow type(${type}) is not define.`;
        }
    }

    //#endregion

    //#region 其他功能

    /**
     * 設定畫筆點擊功能
     * @param {Boolean} isPenClick 
     */
    setPenClick(isPenClick) {
        this.isPenClick = isPenClick;
    }

    /**
     * 取得畫筆點擊功能是否開啟
     */
    getPenClick() {
        return this.isPenClick;
    }

    /**
     * 變更工具類型
     * @param {DEFINE.TOOLS} toolName 
     */
    changeTool(toolName, args = {}, callback = null) {
        this.currentToolName = toolName;
        this.getCurrentPainter().painter.changeTool(this.currentToolName, args);
        EventBus.getInstance().emit("painter_change_tool", this.currentToolName);

        if (callback) {
            callback();
        }
    }

    getCurrentCursor() {
        if (!this.getCurrentPainter().painter) return;
        return this.getCurrentPainter().painter.getCursor();
    }

    /**
     * 更改鼠標
     * @param {string} cursor 
     */
    changeCursor(cursor) {
        let painters = Array.from(this.painterMap.values());

        painters.forEach(painter => {
            painter.changeCursor(cursor);
        })

        this.currentCursor = cursor;
    }

    /**
     * 清除全部
     */
    clearAll(isExcept = true, isClearPage = true) {
        if (!this.getCurrentPainter().painter) return;
        this.getCurrentPainter().painter.clearAll(isExcept, isClearPage);
    }

    clearExceptTarget() {
        if (!this.getCurrentPainter().painter) return;
        this.getCurrentPainter().painter.clearExcept();
    }

    /**
     * 還原
     */
    undo() {
        if (!this.getCurrentPainter().painter) return;
        this.getCurrentPainter().painter.undo();
    }

    /**
     * 取消還原
     */
    redo() {
        if (!this.getCurrentPainter().painter) return;
        this.getCurrentPainter().painter.redo();
    }

    /**
     * 取得相同類型的物件by tag
     * @param {string} tag
     */
    getObjects(tag) {
        if (!this.getCurrentPainter().painter) return null;
        return this.getCurrentPainter().painter.getObjects(tag);
    }

    /**
     * 取得物件by tag
     * @param {string} tag
     */
    getObject(tag) {
        if (!this.getCurrentPainter().painter) return null;
        return this.getCurrentPainter().painter.getObject(tag);
    }

    setStampImg(imgUrl) {
        this.stampImgUrl = imgUrl
    }

    getStampImg() {
        return this.stampImgUrl
    }

    //#endregion

    //#region 存讀檔

    /**
     * 初始化操作紀錄
     */
    initHistory() {
        if (!this.getCurrentPainter().painter) return;

        //TODO:這邊太快新增紀錄會有問題
        setTimeout(() => {
            this.getCurrentPainter().painter.clearHistory();
            this.getCurrentPainter().painter.addHistory();
        })
    }

    /**
     * 儲存主畫布
     * @param {String} key 
     */
    saveMainPainter(key) {
        this.mainPainterSaves.set(key, this.mainPainter.getSave());
    }

    /**
     * 取得主畫布紀錄
     * @param {String} key 
     * @returns JSON
     */
    getMainPainterSave(key) {
        return this.mainPainterSaves.get(key);
    }

    /**
     * 取得當前頁面資料
     */
    getSave() {
        if (!this.getCurrentPainter().painter) return null;
        return this.getCurrentPainter().painter.getSave();
    }

    /**
     * 取得主頁面的畫布紀錄
     * @returns Array
     */
    getMainPainterSaves() {
        const self = this;
        let keys = Array.from(this.mainPainterSaves.keys());

        return keys.map(key => {
            return {
                key: key,
                save: self.mainPainterSaves.get(key)
            }
        })
    }

    setMainPainterSaves(saves) {
        const self = this;
        self.mainPainterSaves.clear();
        saves.forEach(value => {
            if (value.key && value.save) {
                self.mainPainterSaves.set(value.key, value.save);
            }
        })
    }

    /**
     * 載入存檔至當前畫布
     * @param {JSON} save
     */
    loadSave(save) {
        if (!this.getCurrentPainter().painter) return;
        this.getCurrentPainter().painter.loadSave(save);
    }

    /**
     * 載入存檔至主畫布
     * @param {JSON} save
     */
    loadMainPainter(save) {
        this.mainPainter.loadSave(save);
    }

    getPainterSetting(operate) {
        const data = {};
        data.tool = this.getDrawTool(operate);
        data.color = this.getColor(operate);
        data.width = this.getWidth(operate);
        data.isHollow = this.getHollow(operate);

        return data;
    }

    setPainterSetting(operate, data) {
        this.setDrawTool(operate, data.tool);
        this.setColor(operate, data.color);
        this.setWidth(operate, data.width);
        this.setHollow(operate, data.isHollow);

    }

    //#endregion

}